import { wrapNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { lazy } from 'react';

const ConfirmScreenContent = lazy(() => import('./ConfirmScreen.content'));

export const ConfirmScreen = wrapNavigatorScreen(ConfirmScreenContent, {
  headerShown: false,
  animationEnabled: false,
  cardStyle: { backgroundColor: 'transparent' },
  presentation: 'transparentModal',
});
